import { useState, useEffect, createContext, useContext } from 'react';
import React from 'react';
import { Navigate } from 'react-router-dom';

// Create a context to store authentication state
const AuthContext = createContext();

// Main Authentication Provider
export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  const checkAuthentication = () => {
    const userToken = getCookie('token'); // Retrieve token from cookies
    const userId = getCookie('userid');   // Retrieve userid from cookies

    if (userToken && userId) {
      setIsAuthenticated(true);
      localStorage.setItem('isAuthenticated', 'true');
    } else {
      setIsAuthenticated(false);
      localStorage.removeItem('isAuthenticated');
    }
  };

  useEffect(() => {
    // Check auth state on mount (first check from localStorage, then cookie check)
    const storedAuth = localStorage.getItem('isAuthenticated');
    if (storedAuth === 'true') {
      setIsAuthenticated(true);
    } else {
      checkAuthentication();
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated, checkAuthentication }}>
      {children}
    </AuthContext.Provider>
  );
}

// ProtectedRoute component that checks authentication before rendering
export function ProtectedRoute({ element: Component }) {
  const { isAuthenticated } = useAuth();

  const userToken = getCookie('token'); // Retrieve token from cookies
    const userId = getCookie('userid'); 

  if (!userToken && !userId) {
    return <Navigate to="/login" />;
  }

  return <Component />;
}

// Custom hook to access the authentication context
export function useAuth() {
  return useContext(AuthContext);
}

// Helper function to get cookie value by name
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}
